import { render, staticRenderFns } from "./ViHomeHeroSearch.vue?vue&type=template&id=35a2d008&scoped=true"
import script from "./ViHomeHeroSearch.vue?vue&type=script&lang=js"
export * from "./ViHomeHeroSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2d008",
  null
  
)

export default component.exports